import {axios} from "../../helpers/axios";
import { SMTPCONFIG_URL } from "./smtpConstants";

export const api_get_email_config_list_url = async (page,limit,qn,qs) => {
    return axios.get(SMTPCONFIG_URL, { params: {page,limit,qn,qs}});
};

export const api_create_email_config_url = async (data) => {
    return axios.post(SMTPCONFIG_URL, data);
};

export const api_update_email_config_url = async (config_id,updated_data) => {
    return axios.put(SMTPCONFIG_URL + "/" + config_id,updated_data);
};

export const api_activate_deactivate_email_config_url = async (config_id,updated_data) => {
    return axios.patch(SMTPCONFIG_URL + "/" + config_id + "/" + updated_data);
};

export const api_get_email_config_details_url = async (config_id) => {
    return axios.get(SMTPCONFIG_URL + "/" + config_id);
};